import { IconFacebook } from '@/app/components/icons/social-media/icon-facebook';
import { IconFacebookCircle } from '@/app/components/icons/social-media/icon-facebook-circle';
import { IconInstagram } from '@/app/components/icons/social-media/icon-instagram';
import { IconInstagramCircle } from '@/app/components/icons/social-media/icon-instagram-circle';
import { IconLine } from '@/app/components/icons/social-media/icon-line';
import { IconLineCircle } from '@/app/components/icons/social-media/icon-line-circle';
import { IconTiktokCircle } from '@/app/components/icons/social-media/icon-tiktok-circle';
import { IconYoutube } from '@/app/components/icons/social-media/icon-youtube';
import { IconYoutubeCircle } from '@/app/components/icons/social-media/icon-youtube-circle';
import type { SocialMediaLinkType } from '@/app/types/social-media';

export const MENU_LCV_SOCIAL_FACEBOOK_DMAX: SocialMediaLinkType = {
  label: 'ISUZU D-MAX Fanpage',
  href: 'https://www.facebook.com/ALLNEWISUZUDMAX',
  target: '_blank',
  icon: <IconFacebookCircle />,
};

export const MENU_LCV_SOCIAL_FACEBOOK_MUX: SocialMediaLinkType = {
  label: 'ISUZU MU-X Fanpage',
  href: 'https://www.facebook.com/isuzumuxthailand',
  target: '_blank',
  icon: <IconFacebookCircle />,
};

export const MENU_LCV_SOCIAL_LINE: SocialMediaLinkType = {
  label: 'Line Official',
  href: 'https://line.me/R/ti/p/%40isuzuthai',
  target: '_blank',
  icon: <IconLineCircle />,
};

export const MENU_LCV_SOCIAL_YOUTUBE: SocialMediaLinkType = {
  label: 'Youtube Channel',
  href: 'https://www.youtube.com/channel/UCmTP28q4oZsMCyx16PiPJwA',
  target: '_blank',
  icon: <IconYoutubeCircle />,
};

export const MENU_LCV_SOCIAL_INSTAGRAM: SocialMediaLinkType = {
  label: 'Instagram Channel',
  href: 'https://www.instagram.com/isuzuthailandofficial',
  target: '_blank',
  icon: <IconInstagramCircle />,
};

export const MENU_LCV_SOCIAL_TIKTOK: SocialMediaLinkType = {
  label: 'Tiktok Channel',
  href: 'https://www.tiktok.com/@isuzuthailandofficial',
  target: '_blank',
  icon: <IconTiktokCircle />,
};

export const MENU_LCV_SOCIAL_GROUP: SocialMediaLinkType[] = [
  MENU_LCV_SOCIAL_FACEBOOK_DMAX,
  MENU_LCV_SOCIAL_FACEBOOK_MUX,
  MENU_LCV_SOCIAL_LINE,
  MENU_LCV_SOCIAL_YOUTUBE,
  MENU_LCV_SOCIAL_INSTAGRAM,
  MENU_LCV_SOCIAL_TIKTOK,
];

export const MENU_LCV_SOCIAL_REGISTER_GROUP: SocialMediaLinkType[] = [
  { ...MENU_LCV_SOCIAL_FACEBOOK_DMAX, icon: <IconFacebook /> },
  { ...MENU_LCV_SOCIAL_LINE, icon: <IconLine /> },
  { ...MENU_LCV_SOCIAL_YOUTUBE, icon: <IconYoutube /> },
  { ...MENU_LCV_SOCIAL_INSTAGRAM, icon: <IconInstagram /> },
];
